import { useState } from 'react'
import { BarChart } from '@carrent/ui'
import { HOURS, WEEKDAYS } from './format'

/** Гаджет: Активность поездок: два среза в одном гаджете. */

export function TripsActivityWidget({ data }) {
  const [mode, setMode] = useState('hour')

  if (!data.total) {
    return <p className="widget-empty">За период поездок не было</p>
  }

  return (
    <div className="activity">
      <div className="activity__head">
        <span className="text-muted">{data.total} поездок</span>
        <div className="seg">
          <button
            type="button"
            className={`seg__btn ${mode === 'hour' ? 'is-active' : ''}`}
            aria-pressed={mode === 'hour'}
            onClick={() => setMode('hour')}
          >
            Часы
          </button>
          <button
            type="button"
            className={`seg__btn ${mode === 'weekday' ? 'is-active' : ''}`}
            aria-pressed={mode === 'weekday'}
            onClick={() => setMode('weekday')}
          >
            Дни
          </button>
        </div>
      </div>

      {mode === 'hour' ? (
        <BarChart values={data.by_hour} labels={HOURS} label="Поездки по часам суток" />
      ) : (
        <BarChart
          values={data.by_weekday}
          labels={WEEKDAYS}
          color="var(--secondary)"
          label="Поездки по дням недели"
        />
      )}
    </div>
  )
}
